import React from 'react';
import { Link } from 'react-router-dom';

const links = [
  { label: 'Investor Dashboard', to: '/investor' },
  { label: 'Topology Live Monitor', to: '/topology?mode=live' },
  { label: 'Dispatch / SLA', to: '/dadu/penanganan' },
  { label: 'Topology Plan / Design', to: '/topology?mode=plan' },
  { label: 'Installation Pipeline', to: '/dadu/pengajuan-pelanggan' },
  { label: 'Billing / Collection', to: '/dadu/billing' },
];

const QuickDrilldownLinks = () => {
  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Quick Drilldown</h3>
      <div className="mt-3 flex flex-wrap gap-2">
        {links.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="rounded-lg border border-slate-700 bg-slate-950/70 px-3 py-1.5 text-xs text-slate-200 transition hover:border-cyan-500/50 hover:text-cyan-200"
          >
            {item.label}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default QuickDrilldownLinks;
